import React from "react";
import BannerOverlay from "../BannerOverlay/BannerOverlay";
import { Image } from "@project-stories/elements/Image/Image";

const BannerImage = ({ blockItem, section_settings, isMobile, isLazy }) => {
  let imageUrl = blockItem.settings.image?.src ?? blockItem.settings.image;

  let imageHeight = blockItem.image_height;
  let imageWidth = blockItem.image_width;

  if (isMobile) {
    imageUrl = blockItem.settings.mobile_image
      ? blockItem.settings.mobile_image
      : blockItem.settings.image?.src ?? blockItem.settings.image;

      imageHeight = blockItem.mobile_image_height;
      imageWidth = blockItem.mobile_image_width;

  }
  const imageUrlDefined = blockItem.settings.image_url?.length > 0; // Check if a URL is defined

  const ImageContent = ({isLazy = true}) => (
    <div
      className="h-full w-full absolute top-0 left-0 z-[2]">
       {imageUrl && <Image
            imageUrl={imageUrl}
            alt={blockItem.image_alt}
            height={imageHeight}
            width={imageWidth}
            useSrcSet={true}
            classes={
                "object-cover w-full top-0 absolute left-0 h-full"
            }
        />}
    </div>
  );

  return (
    <>
      {blockItem.settings.show_overlay &&
        (imageUrlDefined &&
        (blockItem.settings.button_url === "" ||
          blockItem.settings.button_url === "#") ? (
          <a
            href={blockItem.settings.image_url}
            className="absolute h-full w-full block"
          >
            <BannerOverlay
              blockItem={blockItem}
              section_settings={section_settings}
              isMobile={isMobile}
            />
          </a>
        ) : (
          <BannerOverlay
            blockItem={blockItem}
            section_settings={section_settings}
            isMobile={isMobile}
          />
        ))}
      <div
        className={`banner-image ${blockItem.settings.darken_image && "content-over-media"}`}
      >
        {imageUrlDefined &&
        (blockItem.settings.button_url === "" ||
          blockItem.settings.button_url === "#") ? (
          <a
            href={blockItem.settings.image_url}
            className="h-full w-full block"
          >
            <ImageContent />
          </a>
        ) : (
          <ImageContent/>
        )}
      </div>
    </>
  );
};

export default BannerImage;
